import { cx } from '@linaria/core';
import { baseStyledDatepickerClassNames } from '../styles';
const weekDaysStyles = "ws9m9im";
const weekendsStyles = "w1mmmzc7";
const selectedDaysStyles = "szqnc3i";
const monthDaysStyles = "m56axfg";
export const availabilityDatepickerClassNames = cx(baseStyledDatepickerClassNames, monthDaysStyles, weekDaysStyles, weekendsStyles, selectedDaysStyles);

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");